import React from 'react';
import { Helmet } from 'react-helmet-async';

type PageHeadProps = {
  title: string;
};

const PageHead = ({ title }: PageHeadProps) => {
  return (
    <>
      <Helmet>
        <title>{title} | BirdBuddy</title>
      </Helmet>
    </>
  );
};

export default PageHead;
